import { AI_PROVIDER_TYPES } from './aiProviderTypes';
import { AI_PROVIDER_NAMES } from './aiProviderNames';
import { OUTPUT_TYPES } from './outputTypes';
import { IMAGE_FILE_TYPES, TEXT_FILE_TYPES } from '../../infobase';
export const AI_MODELS = {
    incognito: {
        modelValue: 'incognito',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.AZURE,
        aiProviderName: AI_PROVIDER_NAMES.INCOGNITO,
        attachFilesTypes: [],
        isBrandVoiceSupport: false,
    },
    gpt35Turbo: {
        modelValue: 'gpt35Turbo',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.AZURE,
        aiProviderName: AI_PROVIDER_NAMES.OPENAI,
        attachFilesTypes: [...IMAGE_FILE_TYPES, ...TEXT_FILE_TYPES],
        isBrandVoiceSupport: true,
    },
    aiSearch: {
        modelValue: 'aiSearch',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.AZURE,
        aiProviderName: AI_PROVIDER_NAMES.OPENAI,
        attachFilesTypes: [...IMAGE_FILE_TYPES, ...TEXT_FILE_TYPES],
        isBrandVoiceSupport: true,
    },
    gpt4O: {
        modelValue: 'gpt4O',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.AZURE,
        aiProviderName: AI_PROVIDER_NAMES.OPENAI,
        attachFilesTypes: [...IMAGE_FILE_TYPES, ...TEXT_FILE_TYPES],
        isBrandVoiceSupport: true,
    },
    gpt41Nano: {
        modelValue: 'gpt41Nano',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.AZURE,
        aiProviderName: AI_PROVIDER_NAMES.OPENAI,
        attachFilesTypes: [...IMAGE_FILE_TYPES, ...TEXT_FILE_TYPES],
        isBrandVoiceSupport: true,
    },
    gpt41Mini: {
        modelValue: 'gpt41Mini',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.AZURE,
        aiProviderName: AI_PROVIDER_NAMES.OPENAI,
        attachFilesTypes: [...IMAGE_FILE_TYPES, ...TEXT_FILE_TYPES],
        isBrandVoiceSupport: true,
    },
    gpt41: {
        modelValue: 'gpt41',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.AZURE,
        aiProviderName: AI_PROVIDER_NAMES.OPENAI,
        attachFilesTypes: [...IMAGE_FILE_TYPES, ...TEXT_FILE_TYPES],
        isBrandVoiceSupport: true,
    },
    gpt4OGhibli: {
        modelValue: 'gpt4OGhibli',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.AZURE,
        aiProviderName: AI_PROVIDER_NAMES.OPENAI,
        attachFilesTypes: [...IMAGE_FILE_TYPES, ...TEXT_FILE_TYPES],
        isBrandVoiceSupport: true,
    },
    gpt45: {
        modelValue: 'gpt45',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.AZURE,
        aiProviderName: AI_PROVIDER_NAMES.OPENAI,
        attachFilesTypes: [...IMAGE_FILE_TYPES, ...TEXT_FILE_TYPES],
        isBrandVoiceSupport: true,
    },
    O3Mini: {
        modelValue: 'O3Mini',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.AZURE,
        aiProviderName: AI_PROVIDER_NAMES.OPENAI,
        attachFilesTypes: [...IMAGE_FILE_TYPES, ...TEXT_FILE_TYPES],
        isBrandVoiceSupport: true,
    },
    O3: {
        modelValue: 'O3',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.AZURE,
        aiProviderName: AI_PROVIDER_NAMES.OPENAI,
        attachFilesTypes: [...IMAGE_FILE_TYPES, ...TEXT_FILE_TYPES],
        isBrandVoiceSupport: true,
    },
    O4Mini: {
        modelValue: 'O4Mini',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.AZURE,
        aiProviderName: AI_PROVIDER_NAMES.OPENAI,
        attachFilesTypes: [...IMAGE_FILE_TYPES, ...TEXT_FILE_TYPES],
        isBrandVoiceSupport: true,
    },
    textEmbedding3Large: {
        modelValue: 'textEmbedding3Large',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.AZURE,
        aiProviderName: AI_PROVIDER_NAMES.OPENAI,
        attachFilesTypes: [],
        isBrandVoiceSupport: false,
    },
    dallE3SD: {
        modelValue: 'dallE3SD',
        outputType: OUTPUT_TYPES.IMAGES,
        aiProviderType: AI_PROVIDER_TYPES.AZURE,
        aiProviderName: AI_PROVIDER_NAMES.OPENAI,
        attachFilesTypes: [],
        isBrandVoiceSupport: false,
    },
    dallE3: {
        modelValue: 'dallE3',
        outputType: OUTPUT_TYPES.IMAGES,
        aiProviderType: AI_PROVIDER_TYPES.AZURE,
        aiProviderName: AI_PROVIDER_NAMES.OPENAI,
        attachFilesTypes: [],
        isBrandVoiceSupport: false,
    },
    gpt4Turbo: {
        modelValue: 'gpt4Turbo',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.AZURE,
        aiProviderName: AI_PROVIDER_NAMES.OPENAI,
        attachFilesTypes: [...TEXT_FILE_TYPES],
        isBrandVoiceSupport: true,
    },
    gptO1: {
        modelValue: 'gptO1',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.AZURE,
        aiProviderName: AI_PROVIDER_NAMES.OPENAI,
        attachFilesTypes: [...IMAGE_FILE_TYPES, ...TEXT_FILE_TYPES],
        isBrandVoiceSupport: true,
    },
    gptO1Mini: {
        modelValue: 'gptO1Mini',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.AZURE,
        aiProviderName: AI_PROVIDER_NAMES.OPENAI,
        attachFilesTypes: [],
        isBrandVoiceSupport: false,
    },
    kimi: {
        modelValue: 'kimi',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.KIMI,
        aiProviderName: AI_PROVIDER_NAMES.KIMI,
        attachFilesTypes: [...IMAGE_FILE_TYPES, ...TEXT_FILE_TYPES],
        isBrandVoiceSupport: true,
    },
    claudeSonnet35: {
        modelValue: 'claudeSonnet35',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.AWS,
        aiProviderName: AI_PROVIDER_NAMES.ANTHROPIC,
        attachFilesTypes: [...IMAGE_FILE_TYPES, ...TEXT_FILE_TYPES],
        isBrandVoiceSupport: true,
    },
    claudeSonnet35v2: {
        modelValue: 'claudeSonnet35v2',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.AWS,
        aiProviderName: AI_PROVIDER_NAMES.ANTHROPIC,
        attachFilesTypes: [...IMAGE_FILE_TYPES, ...TEXT_FILE_TYPES],
        isBrandVoiceSupport: true,
    },
    claudeSonnet37: {
        modelValue: 'claudeSonnet37',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.AWS,
        aiProviderName: AI_PROVIDER_NAMES.ANTHROPIC,
        attachFilesTypes: [...IMAGE_FILE_TYPES, ...TEXT_FILE_TYPES],
        isBrandVoiceSupport: true,
    },
    claudeHaiku3: {
        modelValue: 'claudeHaiku3',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.AWS,
        aiProviderName: AI_PROVIDER_NAMES.ANTHROPIC,
        attachFilesTypes: [...IMAGE_FILE_TYPES, ...TEXT_FILE_TYPES],
        isBrandVoiceSupport: true,
    },
    mistralLarge: {
        modelValue: 'mistralLarge',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.AWS,
        aiProviderName: AI_PROVIDER_NAMES.MISTRALAI,
        attachFilesTypes: [...TEXT_FILE_TYPES],
        isBrandVoiceSupport: true,
    },
    grok2: {
        modelValue: 'grok2',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.X,
        aiProviderName: AI_PROVIDER_NAMES.X,
        attachFilesTypes: [...TEXT_FILE_TYPES],
        isBrandVoiceSupport: true,
    },
    grok2vision: {
        modelValue: 'grok2vision',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.X,
        aiProviderName: AI_PROVIDER_NAMES.X,
        attachFilesTypes: [...IMAGE_FILE_TYPES, ...TEXT_FILE_TYPES],
        isBrandVoiceSupport: true,
    },
    grok3Mini: {
        modelValue: 'grok3Mini',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.X,
        aiProviderName: AI_PROVIDER_NAMES.X,
        attachFilesTypes: [...TEXT_FILE_TYPES],
        isBrandVoiceSupport: true,
    },
    grok3: {
        modelValue: 'grok3',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.X,
        aiProviderName: AI_PROVIDER_NAMES.X,
        attachFilesTypes: [...TEXT_FILE_TYPES],
        isBrandVoiceSupport: true,
    },
    grok2image: {
        modelValue: 'grok2image',
        outputType: OUTPUT_TYPES.IMAGES,
        aiProviderType: AI_PROVIDER_TYPES.X,
        aiProviderName: AI_PROVIDER_NAMES.X,
        attachFilesTypes: [],
        isBrandVoiceSupport: false,
    },
    gemini20FlashLite: {
        modelValue: 'gemini20FlashLite',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.GOOGLE,
        aiProviderName: AI_PROVIDER_NAMES.GOOGLE,
        attachFilesTypes: [...IMAGE_FILE_TYPES],
        isBrandVoiceSupport: true,
    },
    gemini20Flash: {
        modelValue: 'gemini20Flash',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.GOOGLE,
        aiProviderName: AI_PROVIDER_NAMES.GOOGLE,
        attachFilesTypes: [...IMAGE_FILE_TYPES],
        isBrandVoiceSupport: true,
    },
    gemini25Flash: {
        modelValue: 'gemini25Flash',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.GOOGLE,
        aiProviderName: AI_PROVIDER_NAMES.GOOGLE,
        attachFilesTypes: [...IMAGE_FILE_TYPES, ...TEXT_FILE_TYPES],
        isBrandVoiceSupport: true,
    },
    gemini25ProExp: {
        modelValue: 'gemini25ProExp',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.GOOGLE,
        aiProviderName: AI_PROVIDER_NAMES.GOOGLE,
        attachFilesTypes: [...IMAGE_FILE_TYPES, ...TEXT_FILE_TYPES],
        isBrandVoiceSupport: true,
    },
    deepseekR1: {
        modelValue: 'deepseekR1',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.DEEPSEEK,
        aiProviderName: AI_PROVIDER_NAMES.DEEPSEEK,
        attachFilesTypes: [],
        isBrandVoiceSupport: true,
    },
    deepseekV3: {
        modelValue: 'deepseekV3',
        outputType: OUTPUT_TYPES.WORDS,
        aiProviderType: AI_PROVIDER_TYPES.DEEPSEEK,
        aiProviderName: AI_PROVIDER_NAMES.DEEPSEEK,
        attachFilesTypes: [...TEXT_FILE_TYPES],
        isBrandVoiceSupport: true,
    },
};
